interface IToken {
  access_token: string;
  iat: number;
  exp: number;
}

export const TOKEN_KEY = "@key-Client";

export const isAuthenticated = () => localStorage.getItem(TOKEN_KEY) !== null;

export const setToken = (token: IToken) => {
  localStorage.setItem(TOKEN_KEY, JSON.stringify(token));
};

export const getToken = () => {
  const user =localStorage.getItem(TOKEN_KEY);

  return JSON.parse(user as string)
};

export const logout = () => {
  localStorage.clear()
};